import { ModuleInterface } from '@creit.tech/stellar-wallets-kit/types';
import * as React from 'react';
import { useEffect, useState } from 'react';

import { AuthService } from 'services/globalServices';

import { ModalProps } from 'types/modal';

import { ExternalLink } from 'basics/links';
import { ModalTitle, ModalWrapper } from 'basics/ModalAtoms';

import {
    LoginMethod,
    LoginMethodDescription,
    LoginMethodName,
    LoginMethodWithDescription,
} from './auth/ChooseLoginMethodModal';
import { ArrowRight } from './WalletKitModal.styled';

const WalletKitModal = ({ params, close }: ModalProps<{ modules: ModuleInterface[] }>) => {
    const [isAvailableMap, setIsAvailableMap] = useState<Map<string, boolean> | null>(null);

    const { modules } = params;

    useEffect(() => {
        let cancelled = false;
        // The SDK preserves each module's `this` and bounds failing/slow extension checks.
        AuthService.walletKit.getSupportedWallets().then(wallets => {
            if (!cancelled) {
                setIsAvailableMap(new Map(wallets.map(wallet => [wallet.id, wallet.isAvailable])));
            }
        });
        return () => {
            cancelled = true;
        };
    }, [modules]);

    return (
        <ModalWrapper>
            <ModalTitle>Stellar Wallets</ModalTitle>

            {modules.map(({ productName, productIcon, productUrl, productId }) => {
                const isAvailable = isAvailableMap?.get(productId);
                return (
                    <LoginMethod
                        key={productId}
                        role="button"
                        aria-label={productName}
                        aria-disabled={!isAvailable}
                        tabIndex={isAvailable ? 0 : -1}
                        onKeyDown={event => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                event.currentTarget.click();
                            }
                        }}
                        onClick={() => {
                            if (!isAvailable) {
                                return;
                            }
                            close();
                            AuthService.walletKit.login(productId);
                        }}
                    >
                        <img src={productIcon} alt={productName} width={40} height={40} />
                        <LoginMethodWithDescription>
                            <LoginMethodName>{productName}</LoginMethodName>
                            {!isAvailableMap ? (
                                <LoginMethodDescription>
                                    Checking availability…
                                </LoginMethodDescription>
                            ) : (
                                !isAvailable && (
                                    <LoginMethodDescription>
                                        <ExternalLink href={productUrl}>Install</ExternalLink>
                                    </LoginMethodDescription>
                                )
                            )}
                        </LoginMethodWithDescription>

                        <ArrowRight />
                    </LoginMethod>
                );
            })}
        </ModalWrapper>
    );
};

export default WalletKitModal;
